import React from 'react'
import { FetchBillingResponse, PaginationResponse } from '../../../../swagger'
import { BillingFilters } from '../interfaces'
import LCDLicensingTable from '../LCDLicensingTable'
import { Box, Card, Paper, useTheme } from '@mui/material'
import Header from '../../../Elements/Header'
import { useTranslation } from 'react-i18next'
import LcdLicensingPaymentHistory from '../LCDLicensingPaymentHistory'

export type LCDBillingViewProps = {
  billingData: FetchBillingResponse
  pagination: Pick<
    PaginationResponse,
    'page' | 'pageSize' | 'totalCount' | 'orderBy'
  >
  handlePagination: (_pagination: PaginationResponse) => void
  filters: BillingFilters
  setFilters: React.Dispatch<React.SetStateAction<BillingFilters>>
}

const LCDBillingView: React.FC<LCDBillingViewProps> = ({
  billingData,
  pagination,
  handlePagination,
  filters,
  setFilters,
}) => {
  const { spacing } = useTheme()
  const { t } = useTranslation()

  return (
    <Card component={Paper}>
      <LCDLicensingTable
        billingData={billingData}
        pagination={pagination}
        handlePagination={handlePagination}
        filters={filters}
        setFilters={setFilters}
      />
      <Box sx={{ padding: spacing(2) }}>
        <Header
          id="LCDBillingViewHeader"
          headerName={t(
            'LCDPaymentHistory.Heading.LicensePayments',
            'License Payments'
          )}
          component="h6"
        />
        <LcdLicensingPaymentHistory />
      </Box>
    </Card>
  )
}

export default LCDBillingView
